/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import { useEffect, useState } from "react";
import { consoleConfig, type ConsoleConfig } from "../api/consoleConfig";

// Environment config, not server state: these values are fixed for the deployment's lifetime,
// so one fetch per page load is cached at module level. This is not the client cache the
// api-layer rules forbid.
let cached: ConsoleConfig | null = null;
let inflight: Promise<ConsoleConfig | null> | null = null;

function loadEnvConfig(): Promise<ConsoleConfig | null> {
  if (cached !== null) {
    return Promise.resolve(cached);
  }
  inflight ??= consoleConfig().then((result) => {
    cached = result.ok ? result.value : null;
    return cached;
  });
  return inflight;
}

export function resetEnvConfigForTests(): void {
  cached = null;
  inflight = null;
}

function useEnvConfig(): ConsoleConfig | null {
  const [config, setConfig] = useState(cached);
  useEffect(() => {
    let cancelled = false;
    void loadEnvConfig().then((value) => {
      if (!cancelled) {
        setConfig(value);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);
  return config;
}

export function useHealthieWebUrl(): string | null {
  return useEnvConfig()?.healthieWebUrl ?? null;
}

/** False until the environment says otherwise: prod must never flash the demo menu. */
export function useDemoEnabled(): boolean {
  return useEnvConfig()?.demoEnabled ?? false;
}
